import EmailTabHeaderComponent
  from 'email-notification-templates/components/email-notification-tab/components/tab-header/tab-header-component';
import template from './tab-header.html';

export default class SmsTabHeaderComponent extends EmailTabHeaderComponent {
  constructor() {
    super();
    this.template = template;
  }
}



// WEBPACK FOOTER //
// ./src/modules/sms/components/sms-notification-templates/components/sms-notification-tab/components/tab-header/tab-header-component.js